import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { primaryButtonSx } from "./approvalUi";

// Reviewers have no account, so edits/remarks are attributed to the name they
// type here. Remembered per browser; storage can be unavailable (private mode),
// so every access is guarded and the page still works without it.
// Shared by every no-login review page (approval share links, plans/PlanReviewPage.jsx).
const NAME_KEY = "scriptReviewerName";
export const readName = () => {
  try {
    return window.localStorage.getItem(NAME_KEY) || "";
  } catch {
    return "";
  }
};
export const writeName = (name) => {
  try {
    window.localStorage.setItem(NAME_KEY, name);
  } catch {
    // not persisted — fine, it's asked for again next visit
  }
};

export const NameDialog = ({ open, initial, onSave }) => {
  const [name, setName] = useState(initial);
  return (
    <Dialog open={open} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: "16px" } }}>
      <DialogTitle sx={{ fontWeight: 700 }}>What's your name?</DialogTitle>
      <DialogContent sx={{ pt: "8px !important" }}>
        <Typography sx={{ fontSize: 13.5, color: "#6B7280", mb: 1.5 }}>
          It's shown next to your edits, approvals and remarks so the team knows who reviewed.
        </Typography>
        <TextField
          fullWidth
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          inputProps={{ maxLength: 80 }}
          onKeyDown={(e) => e.key === "Enter" && name.trim() && onSave(name.trim())}
          placeholder="Your name"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button variant="contained" disabled={!name.trim()} onClick={() => onSave(name.trim())} sx={primaryButtonSx}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
